import { Component, inject, type OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { ModalContainerComponent } from '@components/molecules/modal-container/modal-container.component';
import { ModalService } from '@components/molecules/modal-container/services/modal.service';
import { NotificationListComponent } from '@components/molecules/notification-list/notification-list.component';
import { NotificationService } from '@components/molecules/notification-list/services/notification.service';

import { ThemeService } from '@shared/services/themes.service';

@Component({
	selector: 'neki-root',
	imports: [RouterOutlet, NotificationListComponent, ModalContainerComponent],
	templateUrl: './app.component.html',
	styleUrl: './app.component.scss',
	providers: [NotificationService, ModalService]
})
export class AppComponent implements OnInit {
	private readonly themeService = inject(ThemeService);

	ngOnInit() {
		this.themeService.initializeThemeFromEnvironment();
	}
}
